<template>
  <div class="flex items-center h-full">
    <feather-icon
      icon="Edit2Icon"
      v-if="$can('rp.charges', 'write')"
      @click.prevent.stop="openEdit"
      class="mr-2 cursor-pointer"
      svg-classes="text-primary"
    />
    <feather-icon
      icon="InfoIcon"
      @click.prevent.stop="openMore"
      class="mr-2 cursor-pointer"
      svg-classes="text-primary"
    />
    <feather-icon
      icon="Trash2Icon"
      @click.prevent.stop="deleteRecalculation"
      class="mr-2 cursor-pointer"
      svg-classes="text-primary"
      v-if="$can('rp.charges', 'write')"
    />
  </div>


</template>

<script>
import Vue             from 'vue';
import notifyHttpError from "@/mixins/notifyHttpError";

export default Vue.extend({
  name:    "agActionsColumn",
  mixins:  [notifyHttpError],
  methods: {
    openMore() {
      this.$router.push({
        name:   'uc_b_recalculation',
        params: {
          id: this.params.id,
        },
      });
    },
    promtDelete( { id } ) {
      const params = { buildings_id: this.params.buildingsId };
      return this.$http.delete(`recalculation_group/${id}`, { params }).then(
        () => {
          this.$vs.notify({ color: 'success', title: 'Перерасчет удален', text: 'Перерасчет удален' });
          this.params.onDelete();
        },
        this.notifyHttpError,
      );
    },
    deleteRecalculation() {
      this.$vs.dialog({
        type:       'confirm',
        color:      'danger',
        title:      'Подтверждение',
        text:       'Вы уверены что хотите удалить?',
        acceptText: 'Удалить',
        cancelText: 'Отменить',
        accept:     this.promtDelete,
        parameters: { id: this.params.id },
      });
    },
    openEdit() {
      this.params.onEdit(this.params.params);
    },
  },
});
</script>
